module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[49]536.0074b99.woff2";